import React, { useRef, useState } from "react";
import "./ASGConnect2025Registration.css";

const ASGConnect2025Registration = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);
  const [agree, setAgree] = useState(false); // Track checkbox

  if (!isOpen) return null;

  // Close when clicking outside modal content
  const handleOverlayClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!agree) {
      alert("Please agree to the registration terms before proceeding.");
      return;
    }

    alert("Thank you for registering! 🎉");
    onClose();
  };

  return (
    <div className="asg-modal-overlay" onClick={handleOverlayClick}>
      <div className="asg-modal" ref={modalRef}>
        <button className="asg-close-btn" onClick={onClose}>
          &times;
        </button>

        <h2 className="asg-modal-title">Conference Registration</h2>

        {/* === Replace form with embedded Google Form === */}
        <div className="asg-form-iframe-container">
          <iframe
            src="https://forms.gle/Yix7caFq4rVJX5vPA?embedded=true"
            width="100%"
            height="700"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="ASG Connect 2025 Registration Form"
          >
            Loading…
          </iframe>
        </div>
        {/* <form className="asg-form" onSubmit={handleSubmit}>
          <div className="asg-form-row">
            <div className="asg-form-group">
              <label>Full Name *</label>
              <input type="text" placeholder="Enter your full name" required />
            </div>

            <div className="asg-form-group">
              <label>Email Address *</label>
              <input
                type="email"
                placeholder="your.email@example.com"
                required
              />
            </div>
          </div>

          <div className="asg-form-row">
            <div className="asg-form-group">
              <label>Phone Number *</label>
              <input type="tel" placeholder="+233 XX XXX XXXX" required />
            </div>

            <div className="asg-form-group">
              <label>Category *</label>
              <select required>
                <option value="">Select category</option>
                <option value="member">ASG Member</option>
                <option value="non-member">Non-Member</option>
                <option value="academic">Academic</option>
                <option value="student">Undergrad Student / NSP</option>
                <option value="speaker">Speaker</option>
                <option value="guest">Guest</option>
              </select>
            </div>
          </div>


          <div className="asg-form-row">
            <div className="asg-form-group">
              <label>Organization</label>
              <input
                type="text"
                placeholder="Your organization or company"
              />
            </div>

            Category ID Field
            <div className="asg-form-group">
              <label>Category ID *</label>
              <input
                type="text"
                placeholder="Enter your category ID"
                required
              />
            </div>
          </div>

          Agreement Checkbox
          <div className="asg-checkbox-section">
            <label className="asg-checkbox">
              <input
                type="checkbox"
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                required
              />{" "}
              <span>
                I agree that I am liable and shall pay the applicable <br />
                <strong>CONFERENCE REGISTRATION FEE</strong> for the ASG Actuaries
                Connect Conference 2025.
              </span>
            </label>

            <div className="asg-fee-list">
              <p><strong>ASG Member</strong> – GHS 500.00 <em>(in good standing ONLY)</em></p>
              <p><strong>Non-Member</strong> – GHS 800.00</p>
              <p><strong>Academic</strong> – GHS 500.00</p>
              <p><strong>Undergrad Student/NSPs</strong> – GHS 400.00</p>
            </div>
          </div>

          <button type="submit" className="asg-submit-btn">
            Complete Registration
          </button>
        </form> */}
      </div>
    </div>
  );
};

export default ASGConnect2025Registration;
